module.exports = __webpack_public_path__ + "static/media/menu.146a01a2.svg";